export default __webpack_public_path__ + "static/industrypageHerobg-a4b13f277951765b833a8d6e021153f2.png";